import { Space } from 'antd';
import { ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setProjectDescriptionContains } from 'redux/services/mrsGrouch/projectsParams';
import { useDebouncedCallback } from 'use-debounce';
import { FancyInput } from '../FancyInput';

export const ProjectDescriptionFilter = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setProjectDescriptionContains(ev.target.value));
  }, 500);

  useEffect(() => {
    return (): void => {
      dispatch(setProjectDescriptionContains(undefined));
    };
  }, []);

  /* ****************** Render ****************** */

  return (
    <Space direction="vertical" size="small" style={{ marginLeft: 5, marginRight: 5 }}>
      <FancyInput placeholder="Project Description" onChange={handleInputChange} width={185} />
    </Space>
  );
};
